export const schoolRouteConfig = {
  "/school/dashboard": {
    pageTitle: "Dashboard",
    breadcrumbs: [
      { label: "Home", url: "/school/dashboard" }
    ]
  },

  "/school/students": {
    pageTitle: "Our Students",
    breadcrumbs: [
      { label: "Home", url: "/school/dashboard" },
      { label: "Our Students", url: "/school/students" }
    ]
  },

  "/school/profile": {
    pageTitle: "Profile",
    breadcrumbs: [
      { label: "Home", url: "/school/dashboard" },
      { label: "Profile", url: "/school/profile" }
    ]
  },

  "/school/vehicles": {
    pageTitle: "Fleet & Cars",
    breadcrumbs: [
      { label: "Home", url: "/school/dashboard" },
      { label: "Fleet & Cars", url: "/school/vehicles" }
    ]
  }
};
